import { Component, OnInit } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { HttpClient } from '@angular/common/http';

const azurefunctionsUrl = "https://angr-swisscom-test.azurewebsites.net/api/PSHTest";
const azureFunctionsUrlGraph = "https://angr-swisscom-test.azurewebsites.net/api/PSHGrapAPITest";
export const azurefunctionsBaseUrl = "https://angr-swisscom-test.azurewebsites.net";

@Component({
  selector: 'app-azurefunctions',
  templateUrl: './azurefunctions.component.html',
  styleUrls: ['./azurefunctions.component.css']
})
export class AzurefunctionsComponent implements OnInit {

 output: object;  

  constructor(private authService: MsalService, private http: HttpClient) { }

  ngOnInit() {
    
  }

  runtest(){
    this.http.post(azurefunctionsUrl, {"name": "Azure" })
    .toPromise().then(resp => {
      this.output = resp;
    });
  }

  runPshGraphApiTest(){
    this.http.post(azureFunctionsUrlGraph, {})
    .toPromise().then(resp => {
      this.output = resp;
    });
  }

  runDotNetGraphApiTest(){
    this.http.post("https://angr-swisscom-dotnettest.azurewebsites.net/api/GraphApiTest", {})
    .toPromise().then(resp => {
      this.output = resp;
    });
  }

}
